function persistAuthStatus(status, auth) {
    localStorage.setItem('authStatus', status);
    if (status === 'loggingIn') {
        localStorage.setItem('auth', JSON.stringify(auth));
        localStorage.setItem('state', auth.state);
    }
    else {
        localStorage.removeItem('auth');
        localStorage.removeItem('state');
    }
}
export default persistAuthStatus;
//# sourceMappingURL=index.js.map